// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
import React, { useCallback, useRef, useState } from 'react';
import { Box, Drawer, IconButton, MenuItem, Theme, Typography, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Logo from '@/modules/_core/components/logo/logo.component';
import UserProfileMenu from '../../../_core/components/user-profile-menu/user-profile-menu.component';
import { userProfileMenuStyles } from '@/modules/_core/components/user-profile-menu/user-profile-menu.styles';
import { authStore } from '@/stores';
import { LogOutIcon } from '@/modules/_core/icons';
import { Showable, useStyles } from '@sweatpals/react-ui-kit';
import UserAvatar from '@/modules/_core/components/images/UserAvatar';
import { ChevronLeft } from '@mui/icons-material';
import { checkoutModalNavBarStyles } from './checkout-modal-navbar.styles';

const CheckoutModalNavBar = ({ onClose }: { onClose: () => void }) => {
	const smMedia = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

	const currentUser = authStore.user;

	const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
	const anchorRef = useRef<HTMLElement | null>(null);

	const userMenuStyles = useStyles(userProfileMenuStyles);
	const styles = useStyles(checkoutModalNavBarStyles);

	const handleOpenUserMenu = useCallback(() => {
		setIsUserMenuOpen(true);
	}, []);
	const handleCloseUserMenu = useCallback(() => {
		setIsUserMenuOpen(false);
	}, []);

	const onLogout = useCallback(() => {
		authStore.logout();
		handleCloseUserMenu();
	}, [handleCloseUserMenu]);

	return (
		<Box sx={styles.container}>
			<Logo type="light" sx={styles.logo} layout="fill" />

			<Box sx={styles.rightSection}>
				<Showable show={!!currentUser}>
					<Box sx={styles.userProfileContainer} ref={anchorRef} onClick={handleOpenUserMenu}>
						<UserAvatar user={currentUser} sx={styles.userAvatar} />
						<Typography sx={styles.userName}>{currentUser?.fullName}</Typography>
						<ChevronLeft
							style={{
								color: 'white',
								transform: isUserMenuOpen ? 'rotate(90deg)' : 'rotate(-90deg)',
							}}
						/>
					</Box>
				</Showable>

				<IconButton sx={styles.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</Box>

			<Showable show={smMedia}>
				<UserProfileMenu
					type="compact"
					open={Boolean(isUserMenuOpen)}
					anchorRef={anchorRef}
					onClose={handleCloseUserMenu}
				>
					<MenuItem sx={userMenuStyles.menuItem} onClick={onLogout}>
						<LogOutIcon />
						<Typography variant="inherit">Log Out</Typography>
					</MenuItem>
				</UserProfileMenu>
			</Showable>

			<Showable show={!smMedia}>
				<Drawer sx={styles.mobileDrawer} anchor="bottom" open={isUserMenuOpen} onClose={handleCloseUserMenu}>
					<Box sx={styles.drawerHandle} />
					<MenuItem sx={{ ...userMenuStyles.menuItem, ...styles.mobileMenuItem }} onClick={onLogout}>
						<LogOutIcon />
						<Typography variant="inherit">Log Out</Typography>
					</MenuItem>
				</Drawer>
			</Showable>
		</Box>
	);
};

export default CheckoutModalNavBar;
